import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';

interface MobileProps {
  children: ReactNode;
}

export const Mobile = ({ children }: MobileProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile ? <>{children}</> : null;
};
